module.exports = __webpack_public_path__ + "static/media/lan_access_extra_charge.07ad9108.svg";